import type { FaireProductEntity } from "../../entity_types/product";

export const p_qf5c3nyzq7: FaireProductEntity = {
  token: "p_qf5c3nyzq7",
  type: "product",
  name: "Local | Crewneck",
  brandToken: "b_w2yzf89xa8",
  brandName: "Sunshine + Saltwater",
  imageUrl:
    "https://cdn.faire.com/fastly/c0d2729c023d43630a8ae69aded963119c9592b20ed45f3c6728827e307e0f0c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7b3f85c33bea12440e82f4f28abd02c72040bb1fc7fa0c8028ba209f4e20f37.png",
    "https://cdn.faire.com/fastly/f70fb5810ff2e9d78d3f1063de49ddd79c4e9d486180048a6d33c6e403efdef4.png",
  ],
  priceDollars: 32,
  description:
    "Featuring a pastel rainbow \"LOCAL\" graphic, this cozy classic is the perfect blend of comfort and charm. Whether you’re lounging at home, running errands, or catching up with friends, this sweatshirt wraps you in warmth and connection to the place you love most.\n\nCelebrate your community or favorite beach town with our Local Crewneck Sweatshirt.\n\n * Pill-resistant yarn \n * Double-needle stitching \n * 1x1 ribbed collar, cuffs and waistband with spandex \n * 50% cotton, 50% polyester \n * Heavier fabric (8 oz) \n * Classic fit \nSUNstainability:\nWe believe in shirts that are good for you and the environment, especially our oceans and beaches. This garment meets sustainable materials, manufacturing, and socially conscious manufacturing criteria.\n\nWe are a member and proudly support The Surfrider Foundation which is dedicated to the protection and enjoyment of the world’s oceans, waves and beaches, for all people, through a powerful activist network.\n\n\nCare Instructions:\nWash when dirty, inside out is best + with like colors. \nTumble dry low. And if you really don't know what to do... give it to your Mom - she'll know.\n☀️🌊Add a little sunshine and saltwater to your wardrobe!\n\nOur designs are original works of art by local artists inspired by their love of sunshine + saltwater and of course the beach.\n\nPrinted In The USA 🇺🇸 | Orders will be produced and shipped in 2 -4 days.\n",
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:44.776Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
